import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moneyExchange from "../../assets/icons/moneyExchange.svg";
import { toFormatPrice } from '../common/helpers/function';

const PaymentLogsModalPopup = ({ transcationcounts, pay_data,mode }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const posloc = JSON.parse(localStorage.getItem("pos-loc") || "{}");
    const storeCurrency = posloc?.curr || "";

    const onPaymentLogsTable = () => {
        setIsModalOpen(true); // Open Modal
    };
    const renderTableRows = () => {
        const rows = [];

        // Check if there are any payments
        const hasPayments =
            (Array.isArray(transcationcounts?.cash) && transcationcounts.cash.length > 0) ||
            (pay_data.cash?.amount || 0) > 0 ||
            (Array.isArray(pay_data.credit_card) && pay_data.credit_card.length > 0) ||
            (Array.isArray(pay_data.bank) && pay_data.bank.length > 0) ||
            (Array.isArray(pay_data.IB) && pay_data.IB.length > 0) ||
            pay_data.gift_card;

        // If no payments, show "No payment there"
        if (!hasPayments) {
            return (
                <tr key="no_payment">
                    <td colSpan="3" style={{ textAlign: "center" }}>
                        No payment there
                    </td>
                </tr>
            );
        }

        // Cash
        if (Array.isArray(transcationcounts?.cash) && transcationcounts.cash.length > 0) {
            transcationcounts.cash.forEach((cashRow, index) => {
                const paidAmount = Number(cashRow?.calnumber) || 0;
                const exchange = Number(cashRow?.exchange) || 1;
                const paidCurrency = cashRow?.currency || storeCurrency;
                const storeAmount = paidCurrency === storeCurrency ? paidAmount : paidAmount * exchange;

                rows.push(
                    <tr key={`cash_${index}`}>
                        <td>{`Cash${paidCurrency ? ` (${paidCurrency})` : ""}`}</td>
                        <td>{toFormatPrice(storeAmount, { addSymbol: true })}</td>
                        <td>{`${toFormatPrice(paidAmount, { addSymbol: false })} ${paidCurrency || ""}`}</td>
                    </tr>
                );
            });
        } else if (pay_data.cash?.amount) {
            rows.push(
                <tr key="cash">
                    <td>Cash</td>
                    <td>{toFormatPrice(pay_data.cash.amount, { addSymbol: true })}</td>
                    <td>{`- ${storeCurrency}`}</td>
                </tr>
            );
        }

        // Credit Card
        if (Array.isArray(pay_data.credit_card) && pay_data.credit_card.length > 0) {
            pay_data.credit_card.forEach((card, index) => {
                rows.push(
                    <tr key={`credit_card_${index}`}>
                        <td>{card.name || "Credit Card"}</td>
                        <td>{toFormatPrice(card.amount, { addSymbol: true })}</td>
                        <td>-</td>
                    </tr>
                );
            });
        }

        // Bank
        if (Array.isArray(pay_data.bank) && pay_data.bank.length > 0) {
            pay_data.bank.forEach((bank, index) => {
                rows.push(
                    <tr key={`bank_${index}`}>
                        <td>{bank.name || "Bank"}</td>
                        <td>{toFormatPrice(bank.amount, { addSymbol: true })}</td>
                        <td>-</td>
                    </tr>
                );
            });
        }

        // IB
        if (Array.isArray(pay_data.IB) && pay_data.IB.length > 0) {
            pay_data.IB.forEach((ib, index) => {
                rows.push(
                    <tr key={`ib_${index}`}>
                        <td>{ib.name || "IB"}</td>
                        <td>{toFormatPrice(ib.amount, { addSymbol: true })}</td>
                        <td>-</td>
                    </tr>
                );
            });
        }

        return rows;
    };


    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="dots"style={mode==="cash"?{top:"10vw"}:mode==="bankib"?{top:"13vw"}:mode==="credit-card"?{top:"12vw"}:mode==="bankcheque"?{top:"13vw"}:{top:"12vw"}}>
                <img src={moneyExchange} alt="dots" onClick={onPaymentLogsTable} />
            </div>
            {/* Modal */}
            {isModalOpen && (
                <div
                    className="main-body-row-right-col-inner-payment-tabs-card-bank-btn-row-QrcodeModel"
                    style={{ top: "75%" }}
                >
                    <p className="QrcodeModel-heading">{t("Payment Logs")}</p>
                    <div className="container table-responsive py-1">
                        <table className="table table-bordered table-hover">
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">Type</th>
                                    <th scope="col">{`Amount (${storeCurrency || "Store Curr"})`}</th>
                                    <th scope="col">Amount (Paid Curr)</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableRows()}</tbody>
                        </table>
                    </div>
                    <button
                        className="QrcodeModel-cancel-btn"
                        onClick={() => {
                            setIsModalOpen(false);
                        }}
                    >
                        {t("Ok")}
                    </button>
                </div>
            )}
        </div>
    );
};

export default PaymentLogsModalPopup;
